var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPicture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.75C3.30955 2.75 2.75 3.30955 2.75 4V12C2.75 12.6905 3.30955 13.25 4 13.25H12C12.6905 13.25 13.25 12.6905 13.25 12V4C13.25 3.30955 12.6905 2.75 12 2.75H4ZM1.25 4C1.25 2.48112 2.48112 1.25 4 1.25H12C13.5189 1.25 14.75 2.48112 14.75 4V12C14.75 13.5189 13.5189 14.75 12 14.75H4C2.48112 14.75 1.25 13.5189 1.25 12V4Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 13.125C6.25 9.32788 9.32788 6.25 13.125 6.25C13.4702 6.25 13.7986 6.28317 14.1056 6.32684C14.5157 6.38516 14.8009 6.76488 14.7425 7.17497C14.6842 7.58505 14.3045 7.87021 13.8944 7.81189C13.6287 7.7741 13.3755 7.75 13.125 7.75C10.1563 7.75 7.75 10.1563 7.75 13.125C7.75 13.3755 7.7741 13.6287 7.81189 13.8944C7.87021 14.3045 7.58505 14.6842 7.17497 14.7425C6.76488 14.8009 6.38516 14.5157 6.32684 14.1056C6.28317 13.7986 6.25 13.4702 6.25 13.125Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75491 5.3011C6.35345 4.89963 5.70256 4.89963 5.3011 5.3011C4.89963 5.70256 4.89963 6.35345 5.3011 6.75491C5.70256 7.15637 6.35345 7.15637 6.75491 6.75491C7.15637 6.35345 7.15637 5.70256 6.75491 5.3011ZM7.81557 4.24044C6.82832 3.25319 5.22768 3.25319 4.24044 4.24044C3.25319 5.22768 3.25319 6.82832 4.24044 7.81557C5.22768 8.80281 6.82832 8.80281 7.81557 7.81557C8.80281 6.82832 8.80281 5.22768 7.81557 4.24044Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPicture);
export default __webpack_public_path__ + "static/media/icon-picture.40c96d269d7374d8eba5674c40cafcb9.svg";
export { ForwardRef as ReactComponent };